import type { FaireProductEntity } from "../../entity_types/product";

export const p_df4zvmzr7p: FaireProductEntity = {
  token: "p_df4zvmzr7p",
  type: "product",
  name: "Transitional Oversized Women's Knit Sweater 5161ISW",
  brandToken: "b_ezr3agq73v",
  brandName: "Twentyten",
  imageUrl:
    "https://cdn.faire.com/fastly/f30b469c5b4b97d1179e7697f85614336673b1e8aa0a437b96287f55fdefa696.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d84c96572b66c1fee27bd19936ebaca7f1bd8e6ee6445d6dfa3203db02d68fe6.jpeg",
    "https://cdn.faire.com/fastly/405441921b6ca9614d4a7aa2e89a6a6405d056d5ba25b86199cf7e4926727bac.jpeg",
    "https://cdn.faire.com/fastly/e6455061d06c77ddb378a01ac0d05382b13619051b625efbd492bf5feb297491.jpeg",
    "https://cdn.faire.com/fastly/a16e5a9d4869e09aac45a95bfda5ce326898aaee285aa9c50211a0683ebda7a5.jpeg",
    "https://cdn.faire.com/fastly/bdbecd95b467266e6648fae9bf15447290faf865b8aa0d5a443afdfbfcf1ac23.jpeg",
    "https://cdn.faire.com/fastly/612b88e68e2e2aca0f3c84670650b926b4d2d6831e7ca0a1ad1274f2ee673c07.jpeg",
    "https://cdn.faire.com/fastly/3a7bf64132091851891b936ae8c3cdd321efa67ca18f88d2d66ddb1a20ece475.jpeg",
    "https://cdn.faire.com/fastly/0bd9021f10ab6dc5e983ff9b2fb432c2c4e2a0d4c84ed067a32cf3bdeded54b6.jpeg",
    "https://cdn.faire.com/fastly/87051057caecb1a6076c346a485f2a1bdfeec4b6454b91771c8473e450d799fc.jpeg",
    "https://cdn.faire.com/fastly/ac545448ac3dfafd86cfe4b58d7dbf30fd1ac07e620dd8d08e052e9747512f97.jpeg",
    "https://cdn.faire.com/fastly/c0304c4db6bad00e1382c6416b2eddae581060c8c123af7dff23304a576d5dc3.jpeg",
    "https://cdn.faire.com/fastly/23e6f34836a644c701d5cc3f2977300784e41bba46306c2635b6dcca9657d2d9.jpeg",
    "https://cdn.faire.com/fastly/108479699fb79924cb2257dc86261685cb1c1a59cc7c28a062e5f00defea0b31.jpeg",
    "https://cdn.faire.com/fastly/7816c283f3635ef0dff0ac933bcb3d78abbc2c3ee846981558ecd639001b1a10.jpeg",
    "https://cdn.faire.com/fastly/7a6457559376be0e692cf4ce82b5fa926bea1490cc59e29da4feed6388a7f1e1.jpeg",
    "https://cdn.faire.com/fastly/51747317cb18727ebb8af839f9ff0e35e7d5d954932fa234f05836f49e46be41.jpeg",
    "https://cdn.faire.com/fastly/960341b5eeb342ac129fc9be0f4df0788b481300fc3f6bf10470e4d919a35b8a.jpeg",
  ],
  priceDollars: 4,
  description:
    "TRANSITIONAL OVERSIZED SWEATER KNIT TEE FEATURES SIDE SLIT HEM \n\nMATERIAL: Stretchy knit\nCLOSURE: No\nLINED: No",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:45.913Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
